<template>
    <div class="page-content">
        <Skeleton
            height="50px"
            class="mb-5"
        />

        <Skeleton
            height="30px"
            class="mb-2.5"
        />
        <Skeleton
            height="30px"
            class="mb-5"
        />

        <Skeleton
            height="250px"
            class="mb-5"
        />

        <tl-grid :cols="[1, 1, 2, 2]">
            <Skeleton
                height="250px"
                class="mb-5"
            />
            <Skeleton
                height="250px"
                class="mb-5"
            />
        </tl-grid>
    </div>
</template>

